import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { LogIn, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiErrorDetail(detail) {
  if (detail == null) return "Errore imprevisto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, {
        email: email.trim(),
        password,
      });
      localStorage.setItem("th_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(
        formatApiErrorDetail(err.response?.data?.detail) || err.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="flex min-h-screen items-center justify-center bg-[#06080C] px-6 text-white"
    >
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center justify-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-[#00F562]">
            <span className="font-display text-xs font-black leading-none tracking-tight text-[#06080C]">
              TH
            </span>
          </span>
          <span className="font-display text-base font-extrabold uppercase tracking-widest">
            Talent<span className="text-[#00F562]">Hub</span>
            <span className="ml-2 font-mono text-[10px] font-normal text-slate-500">
              ADMIN
            </span>
          </span>
        </div>

        <form
          data-testid="admin-login-form"
          onSubmit={submit}
          className="rounded-2xl border border-white/[0.08] bg-[#0D111A] p-8"
        >
          <h1 className="font-display text-xl font-bold uppercase tracking-tight">
            Area riservata
          </h1>
          <p className="mt-1 text-xs text-slate-500">
            Accedi per consultare gli iscritti alla waitlist
          </p>

          <input
            data-testid="admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email admin"
            className="mt-6 w-full rounded-xl border border-white/10 bg-[#06080C] px-4 py-3.5 text-sm text-white placeholder-slate-500 outline-none transition-colors duration-300 focus:border-[#00F562]/60"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="mt-3 w-full rounded-xl border border-white/10 bg-[#06080C] px-4 py-3.5 text-sm text-white placeholder-slate-500 outline-none transition-colors duration-300 focus:border-[#00F562]/60"
          />

          {error && (
            <p
              data-testid="admin-login-error"
              className="mt-3 text-xs text-red-400"
            >
              {error}
            </p>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[#00F562] px-6 py-3.5 text-xs font-extrabold uppercase tracking-widest text-[#06080C] transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,245,98,0.5)] disabled:opacity-60"
          >
            <LogIn size={14} />
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>

        <Link
          data-testid="admin-back-home-link"
          to="/"
          className="mt-6 flex items-center justify-center gap-2 text-xs uppercase tracking-widest text-slate-500 transition-colors duration-300 hover:text-[#00F562]"
        >
          <ArrowLeft size={13} />
          Torna alla landing
        </Link>
      </div>
    </div>
  );
}
